import TabsLayout from '@/views/layouts/TabsLayout'

export default function TabsGroup() {
  return <TabsLayout />
}
